export const memoizeOne = <TArgs extends unknown[], TResult>(
    fn: (...args: TArgs) => TResult
): ((...args: TArgs) => TResult) => {
    let isCached = false
    let lastArgs: TArgs | null = null
    let lastResult: TResult

    return (...args: TArgs): TResult => {
        if(
            isCached &&
            lastArgs !== null &&
            lastArgs.length === args.length &&
            args.every((arg, index) => arg === lastArgs![index])
        ) {
            return lastResult
        }

        lastResult = fn(...args)
        lastArgs = args
        isCached = true
        return lastResult
    }
}
